import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import LeaveLogs from "../../components/Leave/LeaveLogs";
import Spinner from "../../components/SpringLoader/index";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import PageShell from "../../components/UI/PageShell";
import { GET, newFetch } from "../../helpers/fetch";

const Leave = () => {
  const { t } = useTranslation();
  const [leaves, setLeaves] = useState([]);
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const fetchAll = async () => {
    try {
      let api_path = `/associate-leaves/${
        JSON.parse(localStorage.getItem("user")).id
      }`;
      let response = await newFetch(GET, api_path);

      if (response.success && response.success) {
        let leaves = response.data;
        setLeaves(leaves);
        setLoading(false);
      } else {
        if (response.success) {
          ToastUtil.success(response.message);
        } else {
          ToastUtil.error(response.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateState = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    fetchAll();
  }, [update]);

  return (
    <PageShell
      title={t("Leave Filling")}
      eyebrow="Time away"
      description="Request leave, review its progress, and check your entitlement."
      actions={
        <>
          <button
            onClick={() => history.push("/leave-entitlement")}
            className="btn btn-outline-brand"
          >
            {t("Leave Entitlement")}
          </button>
          <button
            onClick={() => history.push("/leave-apply")}
            className="btn btn-design btn-brand"
          >
            <i className="fas fa-plus mr-2" aria-hidden="true" />
            {t("Submit Leave")}
          </button>
        </>
      }
    >
        <div className="portal-content-card" id="accordionFAQs">
          {loading ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <LeaveLogs leaves={leaves} updateState={updateState} />
            </React.Fragment>
          )}
        </div>
    </PageShell>
  );
};

export default Leave;
